/**
 * Optional frontend error monitoring hooks (Phase 3D).
 *
 * Fail-open when DSN absent. `@sentry/react` is intentionally NOT a hard
 * dependency — install it and set REACT_APP_SENTRY_DSN when enabling.
 * See docs/ERROR_MONITORING.md.
 */

export function initFrontendMonitoring() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
  if (!dsn) return false;

  // Optional global injector for operators who load Sentry via a separate bundle.
  const injector = typeof window !== "undefined" ? window.__SOKNO_SENTRY_INIT__ : null;
  if (typeof injector === "function") {
    try {
      injector({
        dsn,
        environment:
          process.env.REACT_APP_SENTRY_ENVIRONMENT ||
          process.env.NODE_ENV ||
          "development",
        tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
        sendDefaultPii: false,
      });
      return true;
    } catch {
      return false;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info(
      "[sokno] REACT_APP_SENTRY_DSN is set but no Sentry injector is registered. " +
        "See docs/ERROR_MONITORING.md.",
    );
  }
  return false;
}

export function frontendMonitoringConfigured() {
  return Boolean((process.env.REACT_APP_SENTRY_DSN || "").trim());
}
